import {useRouter, asPath} from "next/router";
import Head from "next/head";
import Navbar from "../../components/general/Navbar";
import HiddenMenu from "../../components/general/HiddenMenu";
import Footer from "../../components/general/Footer";
import Header from "../../components/general/Header";
import {useState, useEffect, useRef} from "react";
import AuthServices from "../../services/Auth.services";
import ToastService from "../../services/Toast.Service";
import InfiniteScroll from "react-infinite-scroll-component";
import ImageLightbox from "../../components/general/ImageLightbox";
import ProductSpecs from "../../components/product/ProductSpecs";
import AvailableSeasonRange from "../../components/product/AvailableSeasonRange";
import AddProductToQuotation from "../../components/pages/producten/partials/AddProductToQuotation";
import ProductSpecsArray from "../../components/product/ProductSpecsArray";

export default function Product({
                                    navigation,
                                    loggedIn,
                                    jwtToken,
                                    product,
                                    otherInvoices,
                                }) {
    const router = useRouter();
    const [selectedVariant, setSelectedVariant] = useState(product);
    const [isFavorite, setIsFavorite] = useState(product?.isFavorite);
    const [reference, setReference] = useState();
    const [referenceDisabled, setReferenceDisabled] = useState(true);
    const [hasCache, setHasCache] = useState(true);
    const [isDisabled, setIsDisabled] = useState(false);

    const [line, setLine] = useState();

    const updateReference = (input) => {
        setReference(input);

        if (input !== null && input !== "") {
            setReferenceDisabled(false);
        } else {
            setReferenceDisabled(true);
        }
    };

    // Correct
    const [offertes, setOffertes] = useState(otherInvoices[0]);

    // Ref
    const [noteInputEl, setNoteInputEl] = useState();
    const [replaceLine, setReplaceLine] = useState();

    // User
    const [userInfo, setUserInfo] = useState();
    const [offertePopupOpen, setOffertePopupOpen] = useState(false);
    const [step, setStep] = useState(1);
    const [selectedImage, setSelectedImage] = useState();
    const [productQuantity, setProductQuantity] = useState();
    const [longitude, setLongitude] = useState();
    const [latitude, setLatitude] = useState();
    const [location, setLocation] = useState();
    const [allImages, setAllImages] = useState([]);
    const [showLightbox, setShowLightbox] = useState(false);
    const [minimumAmount, setMinimumAmount] = useState(product?.minimum_quantity);

    useEffect(() => {
        // fetchImage();
        // turn off until vitum images are fixed
        if (!offertePopupOpen) {
            if (selectedVariant?.variantImages?.length > 0) {
                let images = selectedVariant?.variantImages
                    .filter((image) => image?.filePath)
                    .map((image) => {

                        let url = `https://${process.env.NEXT_PUBLIC_PADDAP_STORAGE_NAME}.blob.core.windows.net/pictures/${image.filePath}`;
                        return {img: url, uid: image.vitumId}
                    });

                if (images?.length <= 0) {
                    fetchImage();
                    return;
                }

                images = images.filter((image, index, self) =>
                    index === self.findIndex((imgObj) => imgObj.img === image.img)
                );

                setAllImages(images);
            } else if (selectedVariant?.product?.productImages?.length > 0) {
                let isMissingFilePath = false;
                let images = selectedVariant?.product?.productImages?.filter((image) => image?.filePath).map((image) => {

                    let url = `https://${process.env.NEXT_PUBLIC_PADDAP_STORAGE_NAME}.blob.core.windows.net/pictures/${image.filePath}`;
                    return {img: url, uid: image.assetId}
                });

                if (images?.length <= 0) {
                    fetchImage();
                    return;
                }

                // Remove duplicate images based on the 'img' property
                images = images.filter((image, index, self) =>
                    index === self.findIndex((imgObj) => imgObj.img === image.img)
                );

                if (isMissingFilePath) {
                    fetchImage();
                }

                setAllImages(images);
            } else {
                fetchImage();
            }
        }
    }, [selectedVariant]);

    const [specOpen, setSpecOpen] = useState(true);
    const toggleOptions = () => {
        setSpecOpen(!specOpen)
        setShowAllOptions((prevShowAll) => !prevShowAll);
    };
    const [showAllOptions, setShowAllOptions] = useState(false);
    const pageData = selectedVariant.product;

    useEffect(() => {
        if (!jwtToken) {
            return;
        }

        setUserInfo(AuthServices.getUserData(jwtToken));

        const stringifiedQuote = localStorage.getItem("quotation");

        if (stringifiedQuote) {
            const cache = JSON.parse(stringifiedQuote);
            setProductQuantity(cache?.quantity ? cache?.quantity : null);
            setNoteInputEl(cache?.note ? cache?.note : null);
            setReplaceLine(cache?.line ? cache?.line : null);
        }
    }, []);

    const setLonLatLocation = (lon, lat, toast) => {
        if (lon && lat) {
            setLongitude(lon);
            setLatitude(lat);
        }

        if (toast) {
            ToastService.successToast("Locatie ophalen geslaagd", toast);
        }
    };

    const setSetLocation = (location) => {
        if (location) {
            setLocation(location);
        }
    };

    const handleAddToInvoice = (e, offerteID = null) => {
        setIsDisabled(true);

        if (localStorage.getItem("quotation")) {
            let cachedQuote = JSON.parse(localStorage.getItem("quotation"));
            setLocalQuote(cachedQuote);

            offerteID = cachedQuote.uid;
        }

        if (e) {
            e.preventDefault();
        }

        let productQuantityCheck = parseInt(productQuantity);
        let minimumAmount_check = parseInt(minimumAmount);

        if (productQuantityCheck < minimumAmount_check) {
            const toast = ToastService.loadToast();
            ToastService.errorToast(
                `De hoeveelheid moet minstens ${minimumAmount} zijn!`,
                toast
            );
            setIsDisabled(false);

            return;
        }

        const makeCal = () => {
            const data = {
                quantity: productQuantity,
                variant_id: selectedVariant?.id,
                note: noteInputEl || "",
                longitude: longitude || "",
                location: location || "",
                latitude: latitude || "",
                image_id: selectedImage || null,
                replace_line: replaceLine ? replaceLine : null,
            };

            if (!data.image_id && allImages?.length >= 1) {
                data.image_id = allImages[0].uid;
            }

            const promise = fetch(
                process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
                "/api/invoices/" +
                offerteID +
                "/add-line",
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                    body: JSON.stringify(data),
                }
            )
                .then((response) => response)
                .then(async (data) => {
                    return {
                        ok: data.ok,
                        data: await data.json(),
                    };
                })
                .then((data) => {
                    if (!data.ok) {
                        throw data.data.message;
                    }

                    router.push("/offerte/bewerken/" + offerteID);
                })
                .catch((error) => {
                    setIsDisabled(false);
                    throw error;
                });

            ToastService.promiseToast(promise);
        };

        if (allImages?.length > 1) {
            if (step === 1) {
                setOffertePopupOpen(true);
                if (offerteID && selectedImage) {
                    makeCal();
                }
            } else {
                makeCal();
            }
        } else {
            if (offerteID) {
                makeCal();
            } else {
                setStep(2);
                setOffertePopupOpen(true);
            }
        }
    };
    const handleNewInvoice = () => {
        const promise = fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/invoices/create",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify({reference: reference}),
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                };
            })
            .then((data) => {
                if (!data.ok) {
                    throw data.data.message;
                }

                handleAddToInvoice("", data.data.uid);
            });

        ToastService.promiseToast(promise);
    };

    const fetchImage = async () => {
        let images = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/products/images/" +
            selectedVariant?.vitemId +
            "?single=0",
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        ).then((response) => response.json());

        if (images?.length > 0) {
            const uniqueImages = images.reduce((acc, image) => {
                if (!acc.find((img) => img.uid === image.uid)) {
                    acc.push(image);
                }
                return acc;
            }, []);

            setAllImages(uniqueImages);
            return;
        }
    };

    const [page, setPage] = useState(1);
    const [moreData, setMoreData] = useState(
        otherInvoices[0]?.length < 20 ? false : true
    );

    const fetchMoreData = async () => {
        setPage(page + 1);

        let newData = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/invoices?" +
            new URLSearchParams({
                limit: 20,
                page: page,
            }),
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        ).then((response) => response.json());
        newData[0]?.length > 0
            ? setOffertes(offertes.concat(newData[0]))
            : setMoreData(false);
    };

    function toggleLightbox() {
        showLightbox === true ? setShowLightbox(false) : setShowLightbox(true);
    }

    const name = `${selectedVariant?.name} ${selectedVariant?.dimension}`

    return (
        <div className="min-h-screen flex flex-col">
            <Head>
                <title>Olaf Nijenkamp | {name}</title>
                <meta name="description" content={name}/>
            </Head>

            <header>
                <Navbar items={navigation}/>
                <HiddenMenu loggedIn={loggedIn} role={userInfo?.role}/>
                <Header
                    title={name}
                    small={true}
                    back={'window'}
                />
            </header>

            <main className="lg:grid lg:grid-cols-12 lg:olafGrid lg:gap-12">
                <div
                    className="relative lg:col-start-10 lg:col-end-13">
                    {product?.available ? (
                        <AddProductToQuotation
                            jwtToken={jwtToken}
                            variant={selectedVariant}
                            loggedIn={loggedIn}
                            userInfo={userInfo}
                            setSetLocation={setSetLocation}
                            setLonLatLocation={setLonLatLocation}
                            product={product}
                            allImages={allImages}
                        />
                    ) : (
                        <p className="mt-16 text-2xl font-bold text-olaf-red-100 text-center">Dit
                            product is niet meer
                            beschikbaar</p>
                    )}
                </div>
                <section className="mt-4 lg:col-start-1 lg:col-end-10 lg:row-start-1">
                    <div className="olafGrid lg:!olafGrid">
                        <div className="hidden lg:block lg:mt-4">
                            <h3 className="font-bold mb-4 lg:text-xl">Naam</h3>
                            <div className="space-y-0 text-sm">
                                {selectedVariant?.product?.greenProperties?.latijnse_naam && (
                                    <p>Latijn: {selectedVariant?.product?.greenProperties?.latijnse_naam}</p>
                                )}
                                <p>Nederlands: {selectedVariant?.product?.greenProperties?.nederlandse_naam}</p>
                            </div>
                        </div>
                        {selectedVariant?.product?.greenProperties?.tekst && (<section className="grid grid-cols-12 mt-4">
                            <div className="col-span-12 md:col-span-8">
                                <p>{selectedVariant?.product?.greenProperties?.tekst}</p>
                            </div>
                        </section>)}
                        <section className="lg:!olafGrid lg:col-start-1 lg:col-end-10 mt-8">
                            <h3 className="mt-4 font-bold lg:text-xl">Afbeeldingen</h3>
                            {allImages.length > 0 && (
                                <div className="mt-4 grid grid-cols-2 lg:grid-cols-4 gap-4">
                                    {allImages.length >= 1 &&
                                        allImages?.map((image, i) => {
                                            return (
                                                <div className="bg-white" key={i}>
                                                    <img
                                                        className="w-full h-full object-cover"
                                                        src={image.img}
                                                        alt={"product afbeelding"}
                                                        onClick={(e) => toggleLightbox(e)}
                                                        onError={({currentTarget}) => {
                                                            currentTarget.onerror = null; // prevents looping
                                                            currentTarget.src =
                                                                "/assets/image/placeholder-logo.jpg";
                                                        }}
                                                    />
                                                </div>
                                            );
                                        })}
                                </div>
                            )}

                            {allImages.length === 0 && (
                                <div className="mt-4 grid grid-cols-2 lg:grid-cols-4 gap-4">
                                    <div className="bg-white">
                                        <img
                                            className="w-full h-full object-cover"
                                            src="/assets/image/placeholder-logo.jpg"
                                            alt={"product afbeelding"}
                                        />
                                    </div>
                                </div>
                            )}
                        </section>
                        {product.available_season && (
                            <AvailableSeasonRange
                                availableSeason={product.available_season}
                            />
                        )}
                        <section className={'!my-10 lg:my-20'}>
                            <ProductSpecsArray pageData={pageData}/>
                        </section>
                    </div>
                </section>

                {/* Offerte add to invoice popup */}
                {offertePopupOpen && (
                    <div
                        className="z-50 fixed top-0 left-0 w-full h-full flex justify-center items-center px-[4%] lg:px-0">
                        <div className="absolute top-0 left-0 w-full h-full bg-black/30"></div>
                        <div className="relative olafGrid bg-white px-4 py-5 rounded-tl-lg rounded-br-lg !max-w-md">
                            {step === 1 && (
                                <>
                                    <h2 className="text-sm lg:text-base">
                                        Kies een afbeelding voor op de offerte
                                        <div
                                            className="absolute top-4 right-[4%] w-6 h-6 cursor-pointer"
                                            onClick={() => (setOffertePopupOpen(false), setStep(1))}
                                        >
                                            <div
                                                className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 rotate-45 rounded-[1px]"></div>
                                            <div
                                                className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 -rotate-45 rounded-[1px]"></div>
                                        </div>
                                    </h2>
                                    <div className="grid grid-cols-3 gap-2 h-80 mt-4 overflow-y-scroll">
                                        {allImages.map((image, i) => (
                                            <img
                                                src={image.img}
                                                key={i}
                                                onClick={() => setSelectedImage(image.uid)}
                                                className={`cursor-pointer aspect-square object-cover ${
                                                    selectedImage === image.uid &&
                                                    "border-4 border-olaf-orange-500 cursor-default"
                                                }`}
                                            />
                                        ))}
                                    </div>
                                    <button
                                        disabled={selectedImage ? false : true}
                                        className={`mt-4 cursor-pointer w-full h-[40px]p p-4 flex items-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 bg-transparent text-olaf-green-500 border-olaf-green-500 hover:bg-olaf-green-500 hover:text-white transition duration-200 ease-in-out ${
                                            selectedImage ? "" : "cursor-not-allowed"
                                        }`}
                                        onClick={() =>
                                            localQuote
                                                ? handleAddToInvoice("", localQuote.uid)
                                                : setStep(2)
                                        }
                                    >
                                        {localQuote
                                            ? "Aan offerte toevoegen"
                                            : "Naar offerte maken"}
                                    </button>
                                </>
                            )}
                            {step === 2 && (
                                <>
                                    <h2 className="text-sm lg:text-base">
                                        Kies een offerte om aan toe te voegen
                                        <div
                                            className="absolute top-4 right-[4%] w-6 h-6 cursor-pointer"
                                            onClick={() => (setOffertePopupOpen(false), setStep(1))}
                                        >
                                            <div
                                                className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 rotate-45 rounded-[1px]"></div>
                                            <div
                                                className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 -rotate-45 rounded-[1px]"></div>
                                        </div>
                                    </h2>
                                    <div className="w-full h-80 overflow-y-auto mt-4">
                                        <InfiniteScroll
                                            dataLength={offertes ? offertes?.length : 0}
                                            next={fetchMoreData}
                                            hasMore={offertes ? moreData : false}
                                            className="!overflow-hidden"
                                            loader={
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="animate-spin w-12 h-12 lg:w-16 lg:h-16 mx-auto mt-8 fill-olaf-orange-500"
                                                >
                                                    <path
                                                        d="M304 48C304 74.51 282.5 96 256 96C229.5 96 208 74.51 208 48C208 21.49 229.5 0 256 0C282.5 0 304 21.49 304 48zM304 464C304 490.5 282.5 512 256 512C229.5 512 208 490.5 208 464C208 437.5 229.5 416 256 416C282.5 416 304 437.5 304 464zM0 256C0 229.5 21.49 208 48 208C74.51 208 96 229.5 96 256C96 282.5 74.51 304 48 304C21.49 304 0 282.5 0 256zM512 256C512 282.5 490.5 304 464 304C437.5 304 416 282.5 416 256C416 229.5 437.5 208 464 208C490.5 208 512 229.5 512 256zM74.98 437C56.23 418.3 56.23 387.9 74.98 369.1C93.73 350.4 124.1 350.4 142.9 369.1C161.6 387.9 161.6 418.3 142.9 437C124.1 455.8 93.73 455.8 74.98 437V437zM142.9 142.9C124.1 161.6 93.73 161.6 74.98 142.9C56.24 124.1 56.24 93.73 74.98 74.98C93.73 56.23 124.1 56.23 142.9 74.98C161.6 93.73 161.6 124.1 142.9 142.9zM369.1 369.1C387.9 350.4 418.3 350.4 437 369.1C455.8 387.9 455.8 418.3 437 437C418.3 455.8 387.9 455.8 369.1 437C350.4 418.3 350.4 387.9 369.1 369.1V369.1z"/>
                                                </svg>
                                            }
                                        >
                                            {offertes
                                                ?.filter((a) => a.status == "DRAFT")
                                                .map(({uid, trackingNumber, reference}, i) => (
                                                    <div
                                                        key={uid}
                                                        className="odd:bg-[#F6F5F3] flex justify-between items-center py-3 px-6 cursor-pointer hover:bg-olaf-green-400/60"
                                                        onClick={() => handleAddToInvoice("", uid)}
                                                    >
                                                        <p className="text-sm">
                                                            {reference ? reference : "#" + trackingNumber}
                                                        </p>
                                                        <img
                                                            src="/assets/icon/chevron-right.svg"
                                                            alt="Remove icon"
                                                            className="ml-auto"
                                                        />
                                                    </div>
                                                ))}
                                        </InfiniteScroll>
                                    </div>

                                    <div className={"mt-4 group"}>
                                        <h2 className="text-sm lg:text-base">
                                            Of maak een nieuwe offerte aan
                                        </h2>

                                        <input
                                            className={`bg-[#F6F5F3] w-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                                referenceDisabled
                                                    ? "group-hover:border-red-500"
                                                    : "group-hover:border-white"
                                            }`}
                                            name={"name"}
                                            placeholder={"Offertenaam"}
                                            type={"text"}
                                            onChange={(e) => updateReference(e.target.value)}
                                        />

                                        <button
                                            disabled={referenceDisabled}
                                            className={`mt-4 cursor-pointer w-full h-[40px]p p-4 flex items-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 bg-transparent text-olaf-green-500 border-olaf-green-500 hover:bg-olaf-green-500 hover:text-white transition duration-200 ease-in-out ${
                                                referenceDisabled ? "cursor-not-allowed" : ""
                                            }`}
                                            onClick={handleNewInvoice}
                                        >
                                            Nieuwe offerte maken
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}

                <section>
                    {showLightbox && (
                        <ImageLightbox
                            toggle={toggleLightbox}
                            isOpen={showLightbox}
                            images={allImages}
                        />
                    )}
                </section>
            </main>
            <Footer/>
        </div>
    );
}

export async function getServerSideProps(context) {
    var loggedIn = context.req.cookies["auth"] ? true : false;
    const jwtToken = context.req.cookies["auth"];

    AuthServices.cookieCheck(jwtToken, context);
    await AuthServices.refreshToken(jwtToken, context);

    let headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");

    if (jwtToken) {
        headers.append("Authorization", "Bearer " + jwtToken);
    }

    const product = await fetch(
        process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
        "/api/products/" +
        context.params.uid,
        {
            method: "get",
            headers: headers,
        }
    ).then((response) => response.json());

    const otherInvoices = await fetch(
        process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
        "/api/invoices?" +
        new URLSearchParams({
            limit: 20,
            page: 0,
        }),
        {
            method: "get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        }
    ).then((response) => response.json());

    let invoiceData = {};
    if (context.query.offerte) {
        invoiceData = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/invoices/" +
            context.query.offerte,
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        ).then((response) => response.json());
    }

    return {
        props: {
            loggedIn: loggedIn,
            jwtToken: jwtToken || null,
            product: product,
            otherInvoices: otherInvoices || null,
            invoiceData: invoiceData,
        }, // will be passed to the page component as props
    };
}
